import axios, { AxiosInstance } from "axios";

export default abstract class BaseApi {
    private readonly axiosInstance: AxiosInstance;

    protected constructor() {
        this.axiosInstance = axios.create();
    }

    protected get api(): AxiosInstance {
        return this.axiosInstance;
    }

    protected set baseUrl(url: string) {
        this.api.defaults.baseURL = url;
    }
}